import { listPlayers } from "../openapi/api-client.ts";
import { useQuery } from "@tanstack/react-query";

export const usePlayerList = () => {
  return useQuery({
    queryKey: ["players"],
    queryFn: async () => {
      const response = await listPlayers({});
      return response.data.players;
    },
  });
};
